import { format } from 'date-fns';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { DEFAULT_ERROR_MESSAGE, PRODUCTION_PLAN } from '../../../constants';
import { apiCall } from '../../../utils/axiosAPIWrapper';
import {
  getGoogleSheetUrl,
  RETAIL_PLAN_INPUTS_URL,
  RETAIL_PRODUCTION_PLAN_METADATA_URL,
} from '../../../utils/serviceUrls';
import {
  GET_RETAIL_PLAN_INPUTS,
  GET_RETAIL_PLAN_INPUTS_ERROR,
  GET_RETAIL_PLAN_INPUTS_SUCCESS,
  GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA,
  GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS,
} from './constants';

function getTimestampDetails(dateValue) {
  if (!dateValue) {
    return {
      date: '-',
      time: '-',
    };
  }
  const date = new Date(dateValue);
  return {
    date: format(date, 'd-MMM-yyyy'),
    time: format(date, 'hh:mm a'),
  };
}

function* getRetailPlanInputs() {
  const { authUserResponse } = yield select((state) => state.authReducer);
  const user = authUserResponse?.email_id;

  try {
    const response = yield call(apiCall, 'GET', RETAIL_PLAN_INPUTS_URL, null, {
      'X-REQUESTED-APP': PRODUCTION_PLAN,
      'X-REQUESTED-BY': user,
    });
    yield put({
      type: GET_RETAIL_PLAN_INPUTS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: GET_RETAIL_PLAN_INPUTS_ERROR,
      payload: 'Something went wrong',
    });
  }
}

function* getRetailProductionPlanTabMetadata() {
  try {
    const { authUserResponse } = yield select((state) => state.authReducer);
    const user = authUserResponse?.email_id;
    const response = yield call(
      apiCall,
      'GET',
      RETAIL_PRODUCTION_PLAN_METADATA_URL,
      null,
      {
        'X-REQUESTED-APP': PRODUCTION_PLAN,
        'X-REQUESTED-BY': user,
      },
    );
    const metadataData = response?.data || response?.metadata || [];
    let list = [];
    if (Array.isArray(metadataData)) {
      list = metadataData.map((each) => ({
        ...each,
        label: each.pcName,
        value: each.id,
        sheetUrl: getGoogleSheetUrl(each.sheetId),
        planGenerated: getTimestampDetails(each.planGeneratedAt),
        planUpdated: getTimestampDetails(each.planUpdatedAt),
        inventoryUpdated: getTimestampDetails(each.inventoryUpdatedAt),
      }));
    }
    yield put({
      type: GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS,
      payload: {
        data: { list },
        error: false,
      },
    });
  } catch (e) {
    const { data } = e || {};
    const { message, error } = data || {};
    yield put({
      type: GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA_SUCCESS,
      payload: {
        error: message || error || DEFAULT_ERROR_MESSAGE,
      },
    });
  }
}

export default function* watcher() {
  yield takeLatest(GET_RETAIL_PLAN_INPUTS, getRetailPlanInputs);
  yield takeLatest(
    GET_RETAIL_PRODUCTION_PLAN_TAB_METADATA,
    getRetailProductionPlanTabMetadata,
  );
}
